import { CheckActions } from 'actions'
import FormsyText from 'formsy-material-ui/lib/FormsyText'
import Formsy from 'formsy-react'
import { Nav, Button } from 'components'
import { Enum } from 'utils'

export default class NotFoundSetup extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  static propTypes = {
    check: React.PropTypes.object.isRequired
  }

  submit(data) {
    CheckActions.activate(
      this.props.check.get('key'),
      this.props.check.get('typeId'),
      data,
      this.context.currentUser
    )
  }

  deactivate() {
    CheckActions.deactivate(this.props.check.get('checkId'))
  }

  render() {
    const { check } = this.props

    return (
      <div>
        <Nav toolbarTitleText={`${check.get('name')}: Set up check`} />
        <div className="setup">
          <div className="setup__form-container">
            <Formsy.Form onValidSubmit={::this.submit}>
              <div>
                <h2 className="setup__form-heading">Set up Your Broken Links Check</h2>
                <h4 className="setup__form-field-title">Warn me when a broken link has been viewed this many times:</h4>
                <FormsyText
                  name='warn_hits'
                  value={check.get('warnHits') || 3}
                  required
                  className="setup__form-field"
                  fullWidth={true}
                />
                <h4 className="setup__form-field-title">Mark as critical when a broken link has been viewed this many times:</h4>
                <FormsyText
                  name='critical_hits'
                  value={check.get('criticalHits') || 10}
                  required
                  className="setup__form-field"
                  fullWidth={true}
                />
              </div>
              <Button 
                type='Submit' 
                buttonType="primary" 
                label='Save and view my results' 
              />
              { check.get('enabled') && check.get('disableable') &&
                <Button 
                  label='deactivate check' 
                  buttonType="secondary" 
                  onTouchTap={::this.deactivate}
                  className="secondary-btn"
                />
              }
            </Formsy.Form>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checker/NotFoundSetup.js